// extracted by mini-css-extract-plugin
export default {"itemCard":"styles_itemCard__ESYHv","txtWrapper":"styles_txtWrapper__MUHw5","typeInfo":"styles_typeInfo__nU3Sq","title":"styles_title__ZgLz-","subtitle":"styles_subtitle__POCH0"};